import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

export default {
  upload: (formData) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/uploadLogoCliente',
      method: 'post',
      body: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

